import { CompositeNavigationProp, RouteProp } from "@react-navigation/native";
import { NativeStackNavigationProp } from "@react-navigation/native-stack";
import { createStackNavigator } from "@react-navigation/stack";
import { UserLoggedInNavigatorNavigationProp } from "../../../../TopLevelNavigators/UserLoggedIn/UserLoggedInNavigatorParamList";

export const WorkspaceSignalStack =
  createStackNavigator<WorkspaceSignalEditStackParamList>();

type WorkspaceSignalEditStackParamList = {
  WorkspaceSignalEditMain: {
    id: string;
    workspaceId: string;
    create?: boolean;
  };
};

export type WorkspaceSignalEditNavigationProp<
  T extends keyof WorkspaceSignalEditStackParamList,
> = CompositeNavigationProp<
  NativeStackNavigationProp<WorkspaceSignalEditStackParamList, T>,
  UserLoggedInNavigatorNavigationProp<"WorkspaceSignalEdit">
>;

export type WorkspaceSignalEditRouteProp<
  T extends keyof WorkspaceSignalEditStackParamList,
> = RouteProp<WorkspaceSignalEditStackParamList, T>;
